import * as types from '../mutation-types';
import { getLogin, getLogout, getChangePassword, getUserDetail, } from '@/api/auth';

const firebase = require("@/firebase/config.js");
import Vue from 'vue'
import store from '@/store'
import "@/utils/filters"


// // state
export const state = {
    token: null,
    status: '',
    user: {
        first_name: '',
        last_name: ''
    },
    currencies: [],
    is_void: false,
    isAuthenticated: false,
    change_password_status: false,
    error_status: 200,
    firebase_init: false,
    available_action: {},
    loading: false,
}

export const getters = {
    user: state => state.user,
    loading: state => state.loading,
    token: state => state.token,
    isAuthenticated: state => state.isAuthenticated,
    status: state => state.status,
    change_password_status: state => state.change_password_status,
    currencies: state => state.currencies,
    firebase_init: state => state.firebase_init,
    is_void: state => state.is_void,
    available_action: state => state.available_action
}

export const mutations = {
    [types.SAVE_TOKEN](state, access_token) {
        state.token = access_token
        state.isAuthenticated = true
    },
    [types.SET_FIREBASE_STATE](state, payload) {
        state.firebase_init = payload;
    },
    [types.FETCH_USER_SUCCESS](state, user) {
        state.status = "SUCCESS";
        state.isAuthenticated = true
        state.user = user;
    },
    [types.FETCH_USER_ACTIONS](state, payload) {
        state.available_action = payload;
    },
    [types.FETCH_CURRENCIES](state, payload) {
        state.currencies = payload;
        state.isAuthenticated = true
    },
    [types.FETCH_USER_FAILURE](state, payload) {
        state.error_status = payload;
        // Object.assign(state, getDefaultState());
    },
    [types.LOGOUT](state, payload) {
        state.token = null,
            state.status = '',
            state.user = {
                first_name: '',
                last_name: ''
            }
    },
    [types.CHANGE_PASSWORD_SUCCESS](state, payload) {
        state.change_password_status = payload
    },
    [types.CHANGE_PASSWORD_ERROR](state, payload) {
        state.change_password_status = payload
    },
    [types.UPDATE_USER](state, user) {
        state.user = user
    },
    [types.FETCH_USER_IS_VOID](state, payload) {
        state.is_void = payload;
    },

    [types.LOGIN](state, payload) {
        state.loading = true;
    },
    [types.LOGIN_FAIL](state, payload) {
        state.loading = false;
        state.token = null;
        state.user = {};
        state.isAuthenticated = false;
    },
    [types.LOGIN_SUCCESS](state, payload) {
        state.loading = false;
        state.token = payload.access_token;
        state.isAuthenticated = true;
        state.user = payload.user;
    },
    [types.CLEAR_AUTH](state, payload) {
        state.user = {};
        state.token = null;
        state.isAuthenticated = false;

    },


}

let unsubscribe;

function notify_by_firestore(flat_state, restaurant) {
    if (unsubscribe !== undefined) {
        unsubscribe();
    }
    unsubscribe = firebase.db.collection('orders')
        .doc("restaurant_" + restaurant.id)
        .onSnapshot({ includeMetadataChanges: false, }, async querySnapshot => {
            let data = querySnapshot.data();
            if (!data) return;
            store.dispatch("order/setCountSalePending", data.count_sale);
            if (flat_state === true) {
                Vue.notify({
                    group: "notification",
                    title: `OrderID: # ${data.order_id} is ${data.status}`,
                    type: "info",
                    speed: 1000,
                    duration: 10000
                });
                if (data.status == 'Pending') {
                    console.log(data.status)
                    let audio = new Audio(require("@/assets/pending.mp3"));
                    audio.play();
                } else {
                    let audio = new Audio(require("@/assets/transaction.mp3"));
                    audio.play();
                }
            }
            flat_state = true;
        });
    return unsubscribe;
}

// actions
export const actions = {
    setFirebase({ commit }, payload) {
        commit(types.SET_FIREBASE_STATE, payload);
    },
    async login({ commit }, payload) {
        commit(types.LOGIN);
        try {
            const response = await getLogin(payload);
            commit(types.LOGIN_SUCCESS, response);
        } catch (error) {
            commit(types.LOGIN_FAIL);
            throw error;
        }
    },
    clearUser({ commit }) {
        commit(types.CLEAR_AUTH)
    },
    async ChangePassword({ commit }, payload) {
        try {
            const old_password = payload.old_password;
            const new_password = payload.password;
            const confirm_password = payload.password_confirmation;
            const response = await getChangePassword(old_password, new_password, confirm_password);
            if (response) {
                commit(types.CHANGE_PASSWORD_SUCCESS, response.data.success)
            }
        } catch (error) {
            const err = error.message;
            commit(types.CHANGE_PASSWORD_ERROR, err);
        }
    },
    async clearAuth({ commit }) {
        commit(types.LOGOUT);
        commit(types.CLEAR_AUTH);
    },
    async signOut({ commit }) {
        try {
            await getLogout();
            commit(types.LOGOUT);
            commit(types.CLEAR_AUTH);
        } catch (error) {
            commit(types.LOGOUT);
            throw error;
        }
    },


    async firestore_init({ commit, getters }, payload) {
        let restaurant = store.getters['restaurant/restaurant'];
        let count_sale = store.getters['order/count_sale'];
        let switch_restaurant = false;
        if (payload) {
            switch_restaurant = payload.state_rest
        }
        if (switch_restaurant === true) {
            count_sale = 0;
        }
        if (count_sale > 0 && switch_restaurant === false) {
            return;
        }
        store.dispatch("order/setCountSalePending", 0);
        commit(types.SET_FIREBASE_STATE, false);
        let flat_state = getters.firebase_init;

        notify_by_firestore(flat_state, restaurant);

        commit(types.SET_FIREBASE_STATE, flat_state);

    },

}